import React, { useMemo, useState } from "react";
const BibloContext = /*#__PURE__*/React.createContext({});
export const BibloProvider = _ref => {
  let {
    components,
    children,
    addons = [],
    ...props
  } = _ref;
  const [selectedFile, setSelectedFile] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [enabledTags, setEnabledTags] = useState([]);
  const {
    indexOptions = {},
    readerOptions = {},
    defaultStyles: defStyles,
    disableDefaultStyles = false,
    textParser = input => input,
    getSection,
    onSelectFile
  } = {
    ...addons.reduce((obj, addon) => typeof addon === "function" ? {
      ...obj,
      ...addon()
    } : {
      ...obj,
      ...addon
    }, {}),
    ...props
  };
  const defaultStyles = {
    spacing: 15,
    lineHeight: 1.25,
    textColor: "#000",
    surfaceColor: "#CCC",
    separatorColor: "#DDD",
    ...defStyles,
    fontSizes: {
      small: 13,
      medium: 15,
      large: 20,
      ...(defStyles === null || defStyles === void 0 ? void 0 : defStyles.fontSizes)
    },
    textInput: {
      height: 40,
      paddingHorizontal: 10,
      backgroundColor: "#FFF",
      borderWidth: 1,
      borderColor: "#CCC",
      ...(defStyles === null || defStyles === void 0 ? void 0 : defStyles.textInput)
    }
  };
  const files = useMemo(() => Object.entries(Object.entries(components).reduce((acc, _ref2) => {
    var _value$default;
    let [path, value] = _ref2;
    if (!(value !== null && value !== void 0 && (_value$default = value.default) !== null && _value$default !== void 0 && _value$default.title)) {
      return acc;
    }
    const {
      default: bio,
      __namedExportsOrder: order,
      ...exports
    } = value;

    // Set which section the component belong in
    const section = bio.section || (getSection ? getSection({
      ...bio,
      path
    }) : "Components");
    if (typeof acc[section] === "undefined") {
      acc[section] = [];
    }
    const items = Object.entries(exports).map(_ref3 => {
      let [title, component] = _ref3;
      return {
        // Convert PascalCase to Title Case
        title: title.replace(/^_$/, "").replace(/([A-Z0-9]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1").replace(/\s+/g, " ").trim().replace(/(\s[A-Z][a-z])/g, match => match.toLocaleLowerCase()),
        originalTitle: title,
        component: component
      };
    });
    if (order !== null && order !== void 0 && order.length) {
      items.sort((a, b) => order.indexOf(a.originalTitle) - order.indexOf(b.originalTitle));
    }
    acc[section].push({
      ...bio,
      path,
      items
    });
    return acc;
  }, {})).map(_ref4 => {
    let [title, data] = _ref4;
    return {
      title,
      data
    };
  }), [components, getSection]);
  return /*#__PURE__*/React.createElement(BibloContext.Provider, {
    value: {
      files,
      selectedFile,
      setSelectedFile,
      onSelectFile,
      indexOptions: {
        ...indexOptions,
        sectionListItemHeight: (indexOptions === null || indexOptions === void 0 ? void 0 : indexOptions.sectionListItemHeight) || 40
      },
      readerOptions,
      defaultStyles,
      disableDefaultStyles,
      textParser,
      searchValue,
      setSearchValue,
      enabledTags,
      setEnabledTags
    }
  }, children);
};
export const useBiblo = () => React.useContext(BibloContext);
//# sourceMappingURL=Biblo.hook.js.map